import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import usePrevious from 'hooks/usePrevious'
import useClient from 'hooks/useClient'
import { useDispatch, useSelector } from 'react-redux'

import { getGovernorates, pullGovernorates } from 'redux/actions/governorates'
import { PERMISSIONS } from 'utils/constants'

import SortableColumnTitle from 'components/SortableColumnTitle'
import PageTable from 'components/PageTable'
import Button from 'components/Button'

const Governorates = () => {
  const { t } = useTranslation()
  const { isClientCan } = useClient()
  const dispatch = useDispatch()
  const [search, setSearch] = useState('')
  const prevSearch = usePrevious(search)

  const { items, pagination, isGetLoading } = useSelector((state) => state.governorates)

  const canPull = isClientCan(PERMISSIONS.UPDATE_CONFIGURATIONS)

  const fetchPage = (page, size, search) => dispatch(getGovernorates({ page, size, search }))

  useEffect(() => {
    if (!items.length) {
      fetchPage(pagination.current, pagination.pageSize, search)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (prevSearch !== undefined && search !== prevSearch) {
      fetchPage(1, pagination.pageSize, search)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, prevSearch])

  const tableChangeHandler = (pagination) => fetchPage(pagination.current, pagination.pageSize, search)

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
      align: 'center',
    },
    {
      title: (props) => <SortableColumnTitle {...props} title={t('locations.governorateName')} id="code" />,
      dataIndex: 'code',
      key: 'code',
      sorter: true,
    },
    {
      title: (props) => (
        <SortableColumnTitle {...props} title={t('locations.governorateNameAr')} id="arabianName" />
      ),
      dataIndex: 'arabianName',
      key: 'arabianName',
      sorter: true,
      render: (text) => (text ? <span dir="rtl">{text}</span> : '-'),
    },
  ]

  return (
    <PageTable
      pageTitle={t('locations.governorates')}
      action={
        canPull ? (
          <Button type="primary" onClick={() => dispatch(pullGovernorates())}>
            <span className="btn-text">{t('promotions.pull')}</span>
          </Button>
        ) : null
      }
      baseData={items}
      columns={columns}
      loading={isGetLoading}
      onChange={tableChangeHandler}
      searchHandler={(value) => setSearch(value.trim())}
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        showSizeChanger: pagination.total >= 10,
      }}
    />
  )
}

export default Governorates

